import React from 'react';
import { DropdownSelect, DropdownSelectOption } from '@keplerco/core';
import styles from './sort-by.module.css';

export function SortBy({ options, value, onChange }: { options: DropdownSelectOption[]; value?: string | number; onChange: React.ChangeEventHandler<HTMLSelectElement> | undefined }): React.ReactElement {
  return (
    <div className={styles.container}>
      <DropdownSelect label="Sort by" options={options} value={value} onChange={onChange} responsive />
    </div>
  );
}
